import { SpinnerIcon } from '@snapi/icons';

export const Loading = () => (
  <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-full bg-white z-50 opacity-75 flex items-center justify-center text-green">
    <div>
      <SpinnerIcon size="5x" />
    </div>
  </div>
);
